<template>
  <div class="w-full h-full overflow-hidden">

    <Modal v-show="show_message_modal" v-bind:display="show_message_modal" :error="this.error" :success="this.success"
      :note="this.warning" z_value="z-50" @positiveClick="closed()" :positiveButton="'OK'" :default_width="'max-w-xl'"
      id='vote_modal'>
      <div class="w-full px-5 pt-2 pb-4 flex flex-col text-xl justify-center text-center items-center">
        {{ this.modal_message }}
      </div>
    </Modal>

    <Modal v-show="show_help_modal" v-bind:display="show_help_modal" z_value="z-50" @closed="closed"
      :default_width="'max-w-md '" id='Help_modal' title="NEED HELP" closable>
      <div class="w-full p-5 flex flex-col text-xl font-bold space-y-1">
        <div
          class="w-full  border rounded shadow-md grid grid-cols-3 h-24 cursor-pointer hover:border-theme-primary hover:border-2 hover:text-theme-primary"
          @click="goto('/forgot-password')">
          <Icon :source="'icons/papsi_forgot_password_icon.svg'" :width="32" class="m-auto" />
          <span v-text="'FORGOT PASSWORD'" class="m-auto col-span-2" />
        </div>
        <div
          class="w-full  border rounded shadow-md grid grid-cols-3 h-24 cursor-pointer hover:border-theme-primary hover:border-2 hover:text-theme-primary"
          @click="openContact">
          <Icon :source="'icons/papsi_contact_us_icon.svg'" :width="32" class="m-auto" />
          <span v-text="'CONTACT US'" class="m-auto col-span-2" />
        </div>
      </div>
    </Modal>

    <!-- PIN Validation-->
    <Modal v-show="show_pin_modal" v-bind:display="show_pin_modal" z_value="z-40" closable id='pin_modal'
      :default_width="'max-w-lg'">
      <div class="pt-6">

        <h2 class="text-2xl lg:text-3xl font-bold text-theme-primary mb-2 text-left">PIN Verification</h2>
        <p class="mb-5 text-left text-base">Please enter your Personal Identification Number (PIN) to proceed.</p>

        <div class="w-full flex flex-row justify-center my-4">
          <v-otp-input :is-disabled="false" ref="deact_pin" input-classes="otp-input" :input-type="pin_type"
            inputmode="numeric" :num-inputs="6" v-model:value="pin_value" :should-auto-focus="true"
            :should-focus-order="true" :key="otpInputKey" @on-complete="validatePIN" @on-change="changePIN" />
          <div class="otp-input flex justify-center items-center text-center bg-gray-100 cursor-pointer"
            @click="togglePeeker()">
            <Icon :source="getImgSrc()" :width="24" />
          </div>
        </div>

        <div class="w-full flex items-center justify-center text-center pt-3 text-base">
          <p>Forgot your PIN? <span class="text-theme-primary font-bold hover:underline cursor-pointer"
              @click="requestOTPPIN">RESET</span></p>
        </div>

        <div v-if="pin_error_message" class="w-full flex items-center justify-center text-center mt-3">
          <div class="text-red-500 text-center bg-red-100 px-4 py-2 rounded-full font-medium text-base"
            v-text="pin_error_message" />
        </div>
      </div>
    </Modal>

    <Modal v-show="this.forgot_PIN" v-bind:display="this.forgot_PIN" z_value="z-40" :default_width="'max-w-xl'"
      id='forgot_modal' closable>
      <div class="pt-6">
        <div class="w-full flex flex-col">
          <div class="" v-show="!show_con_pin">
            <h2 class="text-2xl lg:text-3xl font-bold text-theme-primary mb-2 text-left">Enroll PIN</h2>
            <p class="mb-5 text-left text-base">For enhanced security, please create a unique Personal Identification
              Number (PIN) for future application logins.</p>

            <div class="flex flex-row w-full my-5 justify-center items-center align-center text-center">
              <v-otp-input ref="otpInput" input-classes="otp-input-register"
                :conditionalClass="['pin1', 'pin1', 'pin1', 'pin1', 'pin1', 'pin1']" separator=" "
                :input-type="input_type_pin" inputmode="numeric" :num-inputs="6" @on-change="changePIN"
                @on-complete="checkPinValidity" v-model:value="enroll_pin" :should-auto-focus="true"
                :should-focus-order="true" :key="otpInputKey" />
              <div class="otp-input-register flex justify-center items-center text-center bg-gray-100 cursor-pointer"
                @click="togglePeekerEnroll">
                <Icon v-bind:source="getImgSrc()" :width="24" />
              </div>
            </div>

            <div v-show="error_pin_message" class="w-full flex items-center justify-center text-center">
              <div class="text-red-500 text-center bg-red-100 px-4 py-2 rounded-full font-medium text-base"
                v-text="error_pin_message" />
            </div>
          </div>

          <div class=" text-left" v-show="show_con_pin">
            <h2 class="text-2xl lg:text-3xl font-bold text-theme-primary mb-2 text-left">Confirm PIN</h2>
            <p class="mb-5 text-left text-base">Please re-type your Personal Identification Number (PIN) to confirm.</p>

            <div class="flex flex-row w-full my-5 justify-center items-center text-center">
              <v-otp-input ref="conOtpInput" input-classes="otp-input-register"
                :conditionalClass="['con1', 'con2', 'con3', 'con4', 'con5', 'con6']" separator=" "
                @on-change="changeConPIN" @on-complete="checkPinValidity" :inputType="input_type_con" :num-inputs="6"
                v-model:value="con_enroll_pin" :should-auto-focus="true" :should-focus-order="true"
                :key="otpInputKey" />
              <div class="otp-input-register flex justify-center items-center text-center bg-gray-100 cursor-pointer"
                @click="togglePeekerCon">
                <Icon v-bind:source="getImgSrcCon()" :width="24" />
              </div>

            </div>

            <div v-show="error_pin_message" class="w-full flex items-center justify-center text-center mb-4">
              <div class="text-red-500 text-center bg-red-100 px-4 py-2 rounded-full font-medium text-base"
                v-text="error_pin_message" />
            </div>

            <div class="flex flex-row space-x-3 justify-center mt-2">
              <Button @clicked="backToPin" is_secondary rounded :button_text="lang('BACK')" />
            </div>

          </div>
        </div>
      </div>

    </Modal>

    <!-- show_otp_modal -->
    <Modal v-show="show_otp_modal" v-bind:display="show_otp_modal" :z_value="'z-50'" :default_width="'max-w-xl'"
      id='otp_modal' closable>
      <div class="pt-6">

        <h2 class="text-2xl lg:text-3xl font-bold text-theme-primary mb-2 text-left">OTP Verification</h2>
        <p class="mb-5 text-base text-left">Please enter the One-Time Password (OTP) we have sent to your Email Address
          or Mobile Number to proceed.
        </p>

        <div class="pb-2 w-full justify-items-center font-bold uppercase text-left p-2">
          <v-otp-input :is-disabled="false" ref="otp_input" input-classes="otp-input"
            :conditionalClass="['1', '2', '3', '4', '5', '6']" separator=" " :input-type="'number'" inputmode="numeric"
            :num-inputs="6" @on-complete="submitOTP" @on-change="changeOTP" v-model:value="otp"
            :should-auto-focus="true" :should-focus-order="true" :key="otpInputKey" />
        </div>

        <div class="flex flex-row gap-x-2 pt-3 w-full justify-center text-center text-gray-400 text-sm">
          <p>Didn't receive a code? <span v-show="!show_resend_otp" class="font-semibold">Resend in {{
            formattedTimer }}</span></p>
          <LinkText emit_triggered='resendOtp' @resendOtp="resendOtp" class="text-theme-primary font-bold" text="Resend"
            v-show="show_resend_otp" />
        </div>

        <!-- Error Message Display -->
        <div v-show="otp_error_message" class="w-full flex items-center justify-center text-center mt-4 rounded-full">
          <div class="text-red-500 text-center bg-red-100 px-4 py-2 rounded-full font-medium text-base"
            v-text="otp_error_message" />
        </div>
      </div>
    </Modal>


    <LoadingControl v-show="loading" :loading="loading" />

    <div class="w-full h-full flex flex-col lg:flex-row bg-white">

      <!-- Left Side Background and Logo -->
      <div class="hidden lg:block relative w-full lg:w-3/5 overflow-hidden">
        <!-- Video Background -->
        <video autoplay muted loop playsinline class="absolute inset-0 w-full h-full object-cover z-0">
          <source src="https://resource.pafcpic.net/assets/papsi/papsi_montage.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        <!-- Overlay -->
        <div class="absolute inset-0 z-10 papsi-overlay"></div>

        <!-- Logo -->
        <a href="https://pafcpic.ph/">
          <img src="https://resource.pafcpic.net/assets/logo/papsi_wordmark.png"
            class="absolute top-10 left-10 w-1/4 z-20 cursor-pointer" alt="PAFCPIC Logo" />
        </a>
      </div>

      <!-- Right/Form Section -->
      <div
        class="flex flex-col justify-center w-full lg:w-2/5 min-h-screen px-6 sm:px-8 md:px-12 lg:px-16 xl:px-24 py-10 relative">
        <!-- Mobile Logo -->
        <div class="flex items-start justify-start mb-6 lg:hidden">
          <a href="https://pafcpic.ph/">
            <img src="https://resource.pafcpic.net/assets/logo/papsi_wordmark.png" class="w-1/2 max-w-[200px]"
              alt="PAFCPIC Logo" />
          </a>
        </div>

        <!-- Welcome Text -->
        <h2 class="text-2xl md:text-3xl lg:text-4xl font-bold text-theme-primary mb-2">
          Welcome
        </h2>
        <p class="text-gray-600 text-sm md:text-base mb-4">
          Enter your user credentials to login your account
        </p>

        <!-- Username -->
        <div class="w-full mt-4">
          <TextBoxField :value="username_login" :placeholder="lang('Username')" :has_error="error_message"
            @changed="update" @enter="login" :max_length="23" id="username_login" type="text" />
        </div>

        <!-- Password -->
        <div class="w-full mt-4">
          <form @submit.prevent="login">
            <TextBoxField :value="password" :placeholder="lang('Password')" :has_error="error_message" peekable
              type="Password" @changed="update" @enter="login" :max_length="23" id="password" />
          </form>
        </div>

        <!-- Forgot Password -->
        <div class="w-full flex justify-end text-sm lg:text-base font-semibold">
          <LinkText :text="lang('forgot.password')" :link="'/forgot-password'" />
        </div>

        <!-- Error Message -->
        <transition name="fade">
          <div class="flex justify-center my-4">
            <div v-if="error_message"
              class="inline-block bg-red-100 text-red-500 rounded-full px-4 py-2 font-medium text-center">
              <p>{{ message }}</p>
            </div>
          </div>
        </transition>

        <!-- Login Button -->
        <div class="mt-4">
          <Button :button_text="lang('login.text')" :theme="'text-white'" :max_width="'max-w-full'" @click="login"
            :disabled="isLoginButtonDisabled" />
        </div>

        <!-- Sign Up Link -->
        <div class="flex flex-row justify-center items-center mt-6 text-sm md:text-base text-center text-gray-600">
          <p class="mr-1">Don't have an account?</p>
          <LinkText :text="lang('sign.up.link.text')" bold :link="'/register'" />
        </div>

        <!-- Footer -->
        <footer
          class="w-full text-center text-gray-400 mt-10 pt-6 text-xs sm:text-sm lg:absolute lg:bottom-5 inset-x-0 px-4">
          <div class="flex flex-wrap justify-center gap-3 sm:gap-4">
            <p class="hover:text-theme-primary hover:underline font-medium cursor-pointer"
              @click="$router.push('/about-us')">About Us</p>
            <p class="hover:text-theme-primary hover:underline font-medium cursor-pointer" @click="OpenContact">Contact
              Us</p>
            <p class="hover:text-theme-primary hover:underline font-medium cursor-pointer"
              @click="$router.push('/privacy-policy')">Privacy Policy</p>
            <p class="hover:text-theme-primary hover:underline font-medium cursor-pointer"
              @click="$router.push('/terms-of-use')">Terms</p>
          </div>

          <p class="mt-2">PAFCPIC &copy; {{ new Date().getFullYear() }}</p>
          <div class="mt-1 opacity-40 text-xs font-light">
            Version {{ version }}
          </div>
        </footer>
      </div>
    </div>

  </div>
</template>

<script>
import { defineComponent } from "vue";
import mixin from "@/mixin";
import User from "@/services/User";
import Modal from "@/components/controls/ModalControl.vue";
import TextBoxField from "@/components/controls/TextBoxField.vue";
import Button from "@/components/controls/ButtonControl.vue";
import LinkText from "@/components/controls/LinkText.vue";
import LoadingControl from "@/components/controls/LoadingControl.vue";
import Icon from "@/components/controls/Icon.vue";
import VOtpInput from "vue3-otp-input";
import OTP from "@/services/OTP";

export default defineComponent({
  components: {
    // CardView,
    TextBoxField,
    LoadingControl,
    Button,
    LinkText,
    Modal,
    Icon,
    VOtpInput,

  },
  inject: ['setLoading'],
  data() {
    return {
      version: '',
      enroll_pin: '',
      con_enroll_pin: '',
      enroll_pin_btn: false,
      enroll_conpin_btn: false,
      input_type_pin: 'password',
      input_type_con: 'password',
      username_login: '',
      password: '',
      modal_message: '',
      show_resend_otp: false,
      timerCount: 0,
      timerEnabled: false,
      otpType: '',
      con_visible: false,
      otp: '',
      otpInputKey: 0,
      otp_pin: '',
      otp_token: '',
      pin_type: 'password',
      show_pin_modal: false,
      message: '',
      show: false,
      fade: false,
      loading: false,
      error_message: false,
      show_message_modal: false,
      show_help_modal: false,
      error: false,
      success: false,
      warning: false,
      login_btn: true,
      name: '',
      pin_error_message: '',
      otp_error_message: '',
      pin_value: '',
      visible_pin: false,
      show_otp_modal: false,
      otp_payload: null,
      otpPIN: '',
      otpOTP: '',
      resettingPIN: false,
      forgot_PIN: false,
      show_con_pin: false,
      error_pin_message: ''
    }
  },
  mixins: [
    mixin,
  ],
  props: {
    title: {
      type: String,
      required: false,
    },
  },
  watch: {
    show() {
      setTimeout(() => {
        this.fade = true;
      }, 100);
    },
    timerCount: {
      handler(value) {
        let that = this;
        if (value > 0 && that.timerEnabled) {
          that.show_resend_otp = false;
          setTimeout(() => {
            that.timerCount = that.timerCount - 1;
          }, 1000);
        } else {
          that.show_resend_otp = true;
          that.timerEnabled = false;
        }
      },
      immediate: true
    },
  },
  mounted() {
    this.show = true;
    this.version = process.env.VUE_APP_VERSION;
    if (this.$store.state.logged) {
      this.$router.push('/dashboard');
    }
  },
  computed: {
    isLoginButtonDisabled() {
      return !(this.username_login.trim() && this.password.trim()) || this.login_btn;
    },
    formattedTimer() {
      const min = Math.floor(this.timerCount / 60);
      const sec = this.timerCount % 60;
      return `${min}:${sec.toString().padStart(2, '0')}`;
    }
  },
  methods: {
    checkPinValidity() {
      let that = this;

      const isSequential = (pin) => {
        return '1234567890'.includes(pin) || '0987654321'.includes(pin);
      };

      const isRepeated = (pin) => {
        return /^(\d)\1+$/.test(pin); // Matches all same digits (e.g., 111111)
      };

      // --- Validations ---
      if (that.enroll_pin === "") {
        that.error_pin_validity = true;
        that.error_pin_message = "Don't leave the PIN empty.";
        return;
      }

      if (that.enroll_pin.length < 6) {
        that.error_pin_validity = true;
        that.error_pin_message = 'PIN must be at least 6 digits.';
        return;
      }

      if (isSequential(that.enroll_pin) || isRepeated(that.enroll_pin)) {
        that.error_pin_validity = true;
        that.error_pin_message = 'PIN is too weak.';
        that.enroll_pin_btn = false;
        that.enroll_pin = '';
        that.otpInputKey++;
        return;
      }

      if (that.show_con_pin) {
        if (that.con_enroll_pin === "") {
          that.error_pin_validity = true;
          that.error_pin_message = "Don't leave the PIN empty.";

          return;
        }

        if (that.con_enroll_pin.length < 6) {
          that.error_pin_validity = true;
          that.error_pin_message = 'PIN must be at least 6 digits.';
          return;
        }

        if (that.enroll_pin !== that.con_enroll_pin) {
          that.error_pin_validity = true;
          that.error_pin_message = 'PINs do not match.';
          that.enroll_conpin_btn = false;
          that.con_enroll_pin = '';
          that.otpInputKey++;
          return;
        }

        that.error_pin_validity = false;
        // that.setLoading(true);
        that.setLoading(true);

        let payload = {
          hash: that.hash,
          otp_token: that.otp_token,
          otp_pin: that.otp_pin,
          pin: that.enroll_pin
        };
        const cookie = that.$cookies;

        User.forgotPIN(cookie.get('user').uuid, payload)
          .then(function () {
            that.setLoading(false);
            that.error = false;
            that.note = false;
            that.show_pin_modal = false;
            that.forgot_PIN = false;
            that.success = true;
            that.modal_message = 'Congratulations! You have successfully updated your Personal Identification Number (PIN).';
            that.show_message_modal = true;
          })
          .catch(function (error) {
            that.note_style = "text-center";
            that.setLoading(false);
            that.$refs.conOtpInput?.clearInput();
            that.$refs.otpInput?.clearInput();
            that.backToPin();
            that.error = true;
            that.show_message_modal = true;
            that.modal_message = error.response?.data?.message || 'Something went wrong';
          });

      } else {
        that.error_pin_validity = false;
        that.show_con_pin = true;
        that.show_negative_button = "Back";
        that.modal_button_text = "Submit";
      }
    },
    changePIN() {
      this.error_pin_message = ''
      this.enroll_conpin_btn = false;
      this.pin_error_message = '';
    },
    changeConPIN() {
      this.error_pin_message = '';
      this.enroll_conpin_btn = false;
    },
    backToPin() {
      this.show_con_pin = false;
      this.error_pin_validity = false;
      this.show_negative_button = null;
      this.error_pin_message = '';
      this.modal_button_text = "Next";
    },
    togglePeekerEnroll() {
      if (this.visible == true) {
        this.input_type_pin = "password";
        this.visible = false;
      } else {
        this.input_type_pin = "number";
        this.visible = true;
      }
    },
    togglePeekerCon() {
      if (this.con_visible == true) {
        this.input_type_con = "password";
        this.con_visible = false;
      } else {
        this.input_type_con = "number";
        this.con_visible = true;
      }
    },
    getImgSrcCon() {
      return this.con_visible ? "images/papsi_vis_icon.svg" : "images/papsi_invi_icon.svg";
    },
    changeOTP() {
      this.otp_error_message = '';
    },
    validatePIN() {
      let that = this;

      const cookie = that.$cookies;
      let pin_payload = {
        hash: cookie.get('user_session').hash,
        pin: that.pin_value
      }

      that.setLoading(true);
      that.show_message_modal = false;
      User.validateOldPin(cookie.get('user').uuid, pin_payload).then(function () {
        let config = that.$store.state.credentials.config;
        if (config && config.status) {
          if (!this.$store.state.credentials.email || !this.$store.state.credentials.mobile) {
            that.setLoading(false);
            that.$router.push('/dashboard');
          } else {
            that.setLoading(true);
            that.show_pin_modal = false;
            that.requestOTP();
          }
        } else {
          that.setLoading(false);
          that.$router.push('/dashboard');
        }

      }).catch(function (error) {
        if (error.response.status === 403) {
          that.expired = true;
          that.$store.state.logged = false;
          that.setLoading(false);
          that.error = true;
          that.info = false;
          that.warning = false;
          that.success = false;
          that.show_message_modal = true;
          that.modal_message = "Your session has expired. Please log in again.";
        }
        that.setLoading(false);
        that.pin_error_message = error.response.data.message;
        that.otpInputKey++;
        that.pin_value = '';
      });
    },
    requestOTP() {
      this.setLoading(true);
      let that = this;
      that.otp_payload = {
        type: 1,
        mobile: that.$store.state.credentials.mobile,
        email: that.$store.state.credentials.email,
        name: that.$store.state.credentials.first_name + ' ' + that.$store.state.credentials.last_name
      };
      OTP.requestOtp(that.otp_payload).then(function (response) {
        that.setLoading(false);
        let data = response.data.data
        that.otpPIN = data.pin;
        that.otpOTP = data.otp;
        that.show_otp_modal = true;
        that.show_pin_modal = false;
        that.timerEnabled = true;
        that.resettingPIN = false;
        that.timerCount = 120;

      }).catch(function (error) {
        if (error.response.status == 403) {
          that.expired = true;
          that.error = true;
          that.warning = false;
          that.$store.state.logged = false;
          that.success = false;
          that.info = false;
          that.setLoading(false);
          that.show_otp_modal = false;
          that.show_message_modal = true;
          that.otp = '';
          that.otpInputKey++;
          that.modal_message = "Your session has expired. Please log in again.";

        } else {
          that.setLoading(false);
          that.otp_error_message = error.response.data.message;
          that.otp = '';
          that.modal_message = "Your session has expired. Please log in again.";
          that.warning = false;
          that.success = false;
          that.info = false;
          that.error = true;
          that.otpInputKey++;
        }
      });
    },
    requestOTPPIN() {
      this.setLoading(true);
      this.pin_error_message = '';
      let that = this;
      that.otp_payload = {
        type: 1,
        mobile: that.$store.state.credentials.mobile,
        email: that.$store.state.credentials.email,
        name: that.$store.state.credentials.first_name + ' ' + that.$store.state.credentials.last_name
      };
      OTP.requestOtp(that.otp_payload).then(function (response) {
        that.setLoading(false);
        let data = response.data.data
        that.otpPIN = data.pin;
        that.otpOTP = data.otp;
        that.show_otp_modal = true;
        that.show_pin_modal = false;
        that.timerEnabled = true;
        that.timerCount = 120;
        that.resettingPIN = true;

      }).catch(function (error) {
        if (error.response.status == 403) {
          that.expired = true;
          that.error = true;
          that.warning = false;
          that.$store.state.logged = false;
          that.success = false;
          that.info = false;
          that.setLoading(false);
          that.show_otp_modal = false;
          that.show_message_modal = true;
          that.otp = '';
          that.otpInputKey++;
          that.modal_message = "Your session has expired. Please log in again.";

        } else {
          that.setLoading(false);
          that.otp_error_message = error.response.data.message;
          that.otp = '';
          that.modal_message = "Your session has expired. Please log in again.";
          that.warning = false;
          that.success = false;
          that.info = false;
          that.error = true;
          that.otpInputKey++;
        }
      });
    },
    submitOTP() {
      let that = this;
      that.setLoading(true);
      // const cookie = that.$cookies;
      let payload = {
        otp: that.otp,
        type: 1,
        pin: that.otpPIN
      }
      OTP.validate(payload).then(function (response) {
        that.setLoading(false);
        that.show_otp_modal = false;
        if (that.resettingPIN) {
          that.forgot_PIN = true;
          that.enroll_pin = '';
          that.con_enroll_pin = '';
          that.otp_token = response.data.data.otp_token;
          that.otp_pin = response.data.data.otp_pin;
        } else {
          that.$router.push('/dashboard');
        }
      }).catch(function (error) {
        if (error.response.status == 403) {
          that.expired = true;
          that.error = true;
          that.warning = false;
          that.$store.state.logged = false;
          that.success = false;
          that.info = false;
          that.setLoading(false);
          that.show_otp_modal = false;
          that.show_message_modal = true;
          that.otp = '';
          that.otpInputKey++;
          that.modal_message = "Your session has expired. Please log in again.";

        } else {
          that.setLoading(false);
          that.otp_error_message = error.response.data.message;
          that.otp = '';
          that.otpInputKey++;
        }
      });
    },
    resendOtp() {
      let that = this;
      that.show_resend_otp = false;
      that.timerEnabled = true;
      that.timerCount = 120;
      that.otp_payload = {
        type: 1,
        mobile: that.$store.state.credentials.mobile,
        email: that.$store.state.credentials.email,
        name: that.$store.state.credentials.first_name + ' ' + that.$store.state.credentials.last_name
      };
      OTP.requestOtp(that.otp_payload).then(function (response) {
        that.setLoading(false);
        let data = response.data.data
        that.otpPIN = data.pin;
        that.otpOTP = data.otp;
      }).catch(function (error) {
        if (error.response.status == 403) {
          that.expired = true;
          that.error = true;
          that.$store.state.logged = false;
          that.modal_message = "Your session has expired. Please log in again.";
          that.show_otp_modal = false;
        }
        that.modal_message = error.response.data.message;
        that.show_otp_modal = false;
        that.error = true;
        that.show_otp_modal = false;
        that.warning = false;
        that.info = false;
        that.success = false;
        that.setLoading(false);
        that.show_message_modal = true;
      });
    },
    togglePeeker() {
      if (this.pin_type == 'password') {
        this.visible_pin = true;
        this.pin_type = 'number';
      } else {
        this.visible_pin = false;
        this.pin_type = 'password';
      }
    },
    getImgSrc() {
      return this.visible_pin ? "images/papsi_vis_icon.svg" : "images/papsi_invi_icon.svg";
    },
    openContact() {
      this.show_help_modal = false;
      this.$emit('openContact');

    },
    goto(event) {
      this.$router.push(event);
    },
    getThumbnail() {
      return 'background-image: url(' + this.image + ');';

    },
    showHelp() {
      this.show_help_modal = true;
    },
    closed() {
      let that = this;

      if (that.resettingPIN) {
        that.$router.push('/dashboard');
      } else {
        that.show_message_modal = false;
        that.show_help_modal = false;
      }
    },
    update(e) {
      let key = e.key;
      let that = this;
      that.error_message = false;
      that[key] = e.value;
      that.login_btn = false;
    },
    authenticated(values) {
      const that = this;
      const store = that.$store;
      const state = store.state;
      const cookie = that.$cookies;

      let payload = {
        username: that.username_login,
        password: that.password,
        hash: values.hash,
        type: 1
      }


      User.authentication(payload, values.uuid).then(function (response) {
        let data = response.data.data;

        cookie.set('user_session', {
          hash: data.hash,
        });
        state.credentials.has_pin = data.has_pin;
        state.credentials.account_no = data.info.account_number;
        state.credentials.email = data.info.email;
        state.credentials.key = data.key;
        state.credentials.mobile = data.info.mobile;
        state.credentials.name = data.info.first_name + " " + data.info.last_name + " " + (data.info.suffix ? " " + data.info.suffix : "")
        state.credentials.first_name = data.info.first_name;
        state.credentials.last_name = data.info.last_name;
        state.credentials.middle_name = data.info.middle_name;
        state.credentials.suffix = data.info.suffix ?? '';
        state.credentials.qr = data.qr;
        state.credentials.regular = data.info.regular;
        state.credentials.serial_no = data.info.serial_number;
        state.credentials.timestamp = response.timestamp;
        state.credentials.username = data.info.username;
        state.credentials.tin = data.info.tin;
        state.credentials.hash = data.hash;
        state.credentials.gender = data.info.gender;
        state.credentials.birthdate = data.info.date_of_birth;
        state.credentials.age = data.info.age;
        state.credentials.membership_type = data.info.membership_type;
        state.credentials.serial_no = data.info.serial_number;
        state.credentials.express = data.express;
        state.credentials.deactivated = data.deactivated;
        state.credentials.pso_enroll = data.pso_enroll;
        state.credentials.pin_update = data.pin_update;
        state.credentials.hash = data.hash;
        state.credentials.registered_date = data.info.registered;
        state.gaUser = data.ga;
        state.balances = data.balances;
        // console.log('balances: ', state.balances);
        const type2Config = data.config.find(item => item.type === 2);

        if (type2Config) {
          state.credentials.config = { status: type2Config.status };
        } else {
          state.credentials.config = null;
        }
        state.logged = true;
        that.$cookies.remove('validated');
        that.otp = '';
        that.otpInputKey++;
        that.pin_value = '';
        that.setLoading(false);

        state.transaction_cache = {};
        state.transaction_data = [];
        state.transaction_label = '';
        state.transaction_balance = 0;
        state.transaction_key = '';
        state.transaction_date = '';
        state.last_sync = '';
        that.$router.push('/dashboard');

      }).catch(function (error) {
        let message = error.response.data.message;
        that.modal_message = message;
        that.show_message_modal = true;
        that.error = true;
        that.error_message = true;
        that.message = message;
        that.setLoading(false);
      })
    },
    getUserInfo() {
      let that = this;
      const cookie = that.$cookies;
      const store = that.$store;
      let state = store.state;
      that.setLoading(true);
      User.getuserInfo(cookie.get('user')).then(function (response) {
        let user_data = response.data.data;
        state.credentials.has_pin = user_data.has_pin;
        state.credentials.name = user_data.account.username;
        state.credentials.first_name = user_data.info.first_name;
        state.credentials.last_name = user_data.info.last_name;
        state.credentials.middle_name = user_data.info.middle_name;
        state.credentials.gender = user_data.info.gender;
        state.credentials.regular = user_data.info.regular;
        state.credentials.account_no = user_data.info.account_no;
        state.credentials.serial_no = user_data.info.serial_no;
        state.credentials.tin = user_data.info.tin;
        state.credentials.email = user_data.account.email;
        state.credentials.mobile = user_data.account.mobile;
        state.credentials.username = user_data.account.username;
        state.credentials.status = user_data.info.status;
        state.credentials.membership_type = user_data.info.membership_type;
        state.credentials.qr = user_data.qr;
        state.credentials.uuid = user_data.uuid;
        state.credentials.hash = cookie.get('user').hash;
        state.credentials.key = user_data.key;
        state.credentials.express = user_data.account.express;
        state.credentials.deactivated = user_data.account.deactivated;
        state.balances = user_data.balances;
        that.setLoading(false);


      }).catch(function (error) {
        that.error = true;
        that.setLoading(false);
        that.show_message_modal = true;
        that.modal_message = error.response.data.message;
      });
    },
    OpenAbout() {
      this.$emit('OpenAbout');
    },
    OpenContact() {
      this.$emit('OpenContact');
    },
    OpenTerms() {
      this.$emit('OpenTerms');
    },
    OpenPrivacy() {
      this.$emit('OpenPrivacy');
    },
    login() {
      if (!this.isLoginButtonDisabled) {
        const that = this;
        const cookie = that.$cookies;
        const store = that.$store;
        that.login_btn = true;
        that.setLoading(true);
        User.login(that.username_login, that.password).then(function (response) {
          let data = response.data.data;
          cookie.set('user', {
            uuid: data.uuid,
            hash: data.hash,
            timestamp: data.timestamp,
          });
          store.state.credentials.hash = data.hash;
          store.state.credentials.uuid = data.uuid;
          that.authenticated(cookie.get('user'));
        }).catch(function (error) {
          that.setLoading(false);
          that.login_btn = false;
          let message = error.response.data.message;
          that.modal_message = message;
          that.error = true;
          that.error_message = true;
          that.message = message;
        })
      }

    }
  },

});
</script>

<style scoped>
.static-height {
  height: 600px;
}

.background-image {
  width: 100%;
  margin: auto;
  place-content: center;
}

.card-gradient {
  background-image: linear-gradient(to bottom, #019C00, #FEE765);
}

.circle-gradient {
  background-image: linear-gradient(to right, #FEE765, #019C00);
}
</style>